import { getUserData } from '@/auth/utils'
import appConstants from '@/constants/constants'

export const advisoryOpinionSaveLineBreaks = () => {
  const settings = getUserDocumentSettings()
  return !!(settings && settings.advisory_opinion_save_line_breaks)
}

export const advisoryOpinionShowDoctorPosition = () => {
  const settings = getUserDocumentSettings()
  return !(settings && !settings.advisory_opinion_show_doctor_position)
}

export const advisoryOpinionHiddenFields = () => {
  const settings = getUserDocumentSettings()
  return settings && settings.advisory_opinion_hidden_fields ? settings.advisory_opinion_hidden_fields.split(',') : []
}

export const dentalCardUseConsentProcessingPersonalData = () => {
  const settings = getUserDocumentSettings()
  return settings && settings.hasOwnProperty('dental_card_use_consent_processing_personal_data')
    ? settings.dental_card_use_consent_processing_personal_data : true
}

export const dentalCardUseActualMainPageFormat = () => {
  const settings = getUserDocumentSettings()
  return settings && settings.hasOwnProperty('dental_card_actual_main_page_format')
    ? settings.dental_card_actual_main_page_format : false
}

export const dentalCardUseConsentProcessingPersonalDataPage = () => {
  const settings = getUserDocumentSettings()
  return settings && settings.hasOwnProperty('dental_card_use_consent_processing_personal_data_page')
    ? settings.dental_card_use_consent_processing_personal_data_page : false
}

export const dentalCardUseCompactDentalStatus = () => {
  const settings = getUserDocumentSettings()
  return settings && settings.hasOwnProperty('dental_card_compact_dental_status')
    ? settings.dental_card_compact_dental_status : false
}

export const dentalCardUseInternalRegulations = () => {
  const settings = getUserDocumentSettings()
  return settings && settings.hasOwnProperty('dental_card_use_internal_regulations')
    ? settings.dental_card_use_internal_regulations : true
}

export const dentalCardUseMedicalInterventionVoluntaryConsent = () => {
  const settings = getUserDocumentSettings()
  return settings && settings.hasOwnProperty('dental_card_use_medical_intervention_voluntary_consent')
    ? settings.dental_card_use_medical_intervention_voluntary_consent : true
}

export const dentalCardUseEarlyDetectionQuestionnaire = () => {
  const settings = getUserDocumentSettings()
  return settings && settings.hasOwnProperty('dental_card_use_early_detection_questionnaire')
    ? settings.dental_card_use_early_detection_questionnaire : true
}

export const dentalCardUseMedicalInterventionPreliminaryConsent = () => {
  const settings = getUserDocumentSettings()
  return settings && settings.hasOwnProperty('dental_card_use_medical_intervention_preliminary_consent')
    ? settings.dental_card_use_medical_intervention_preliminary_consent : true
}

export const dentalCardPrintFormat = () => {
  const settings = getUserDocumentSettings()
  return settings && settings.dental_card_print_format
    ? settings.dental_card_print_format : appConstants.setting.printFormat.APP_A4
}

export const documentLogoRightPosition = () => {
  const settings = getUserDocumentSettings()
  return !!(settings && settings.logo_right_position)
}

export const documentIntegratorInfoWithLogo = () => {
  const settings = getUserDocumentSettings()
  return !!(settings && settings.integrator_info_with_logo)
}

export const actShowRecommendations = () => {
  const settings = getUserDocumentSettings()
  return !!(settings && settings.act_show_recommendations)
}

export const actContractNumberInsteadOfActNumber = () => {
  const settings = getUserDocumentSettings()
  return !!(settings && settings.act_contract_number_instead_of_act_number)
}

export const actContractNumberHidden = () => {
  const settings = getUserDocumentSettings()
  return !!(settings && settings.act_contract_number_hidden)
}

export const actFillSignerDoctorName = () => {
  const settings = getUserDocumentSettings()
  return !!(settings && settings.act_fill_signer_doctor_name)
}

export const actShowPatientSignature = () => {
  const settings = getUserDocumentSettings()
  return settings && settings.hasOwnProperty('act_show_patient_signature')
    ? settings.act_show_patient_signature : true
}

export const actMedicalServiceRenderedShowPatientSignature = () => {
  const settings = getUserDocumentSettings()
  return settings && settings.hasOwnProperty('act_medical_service_rendered_show_patient_signature')
    ? settings.act_medical_service_rendered_show_patient_signature : true
}

export const actShowPatientBirthdate = () => {
  const settings = getUserDocumentSettings()
  return settings && settings.hasOwnProperty('act_show_patient_birthdate')
    ? settings.act_show_patient_birthdate : false
}

export const actShowPatientDocumentSerialNumber = () => {
  const settings = getUserDocumentSettings()
  return settings && settings.hasOwnProperty('act_show_patient_document_serial_number')
    ? settings.act_show_patient_document_serial_number : false
}

export const actShowPatientDocumentIdentifier = () => {
  const settings = getUserDocumentSettings()
  return settings && settings.hasOwnProperty('act_show_patient_document_identifier')
    ? settings.act_show_patient_document_identifier : false
}

export const actPatientLabel = () => {
  const settings = getUserDocumentSettings()
  return settings && settings.act_patient_label ? settings.act_patient_label : 'Пациент'
}

export const actOfServiceRenderedShowTotalPrices = () => {
  const settings = getUserDocumentSettings()
  return !!(settings && settings.act_of_service_rendered_show_total_prices)
}

export const complexActHideColumnPrice = () => {
  const settings = getUserDocumentSettings()
  return !!(settings && settings.complex_act_hide_column_price)
}

export const complexActHideColumnCount = () => {
  const settings = getUserDocumentSettings()
  return !!(settings && settings.complex_act_hide_column_count)
}

export const purchaseOrderExecutorLabel = () => {
  const settings = getUserDocumentSettings()
  return settings && settings.purchase_order_executor_label ? settings.purchase_order_executor_label : 'Исполнитель'
}

export const purchaseOrderAdministratorHidden = () => {
  const settings = getUserDocumentSettings()
  return !!(settings && settings.purchase_order_administrator_hidden)
}

export const purchaseOrderShowServicesText = () => {
  const settings = getUserDocumentSettings()
  return !!(settings && settings.purchase_order_show_services_text)
}

export const purchaseOrderFillExecutorDoctorName = () => {
  const settings = getUserDocumentSettings()
  return !!(settings && settings.purchase_order_fill_executor_doctor_name)
}

export const purchaseOrderShowDiagnosis = () => {
  const settings = getUserDocumentSettings()
  return !!(settings && settings.purchase_order_show_diagnosis)
}

export const generalMedicalCardHideResidencePlaceDetailedFields = () => {
  const settings = getUserDocumentSettings()
  return !!(settings && settings.general_medical_card_hide_residence_place_detailed_fields)
}

export const generalMedicalCardPrintFormat = () => {
  const settings = getUserDocumentSettings()
  return settings && settings.general_medical_card_print_format
    ? settings.general_medical_card_print_format : appConstants.setting.printFormat.APP_A4
}

export const useInsuranceConsolidatedAccountAutoNumber = () => {
  const settings = getUserDocumentSettings()
  return !!(settings && settings.insurance_consolidated_account_auto_number)
}

export const acceptanceActInAccordanceWith = () => {
  const settings = getUserDocumentSettings()
  return settings && settings.acceptance_act_in_accordance_with
    ? settings.acceptance_act_in_accordance_with
    : appConstants.setting.documentsSettings.acceptanceAct.IN_ACCORDANCE_WITH_TEXT
}

export const acceptanceActFamiliarWith = () => {
  const settings = getUserDocumentSettings()
  return settings && settings.acceptance_act_familiar_with
    ? settings.acceptance_act_familiar_with : appConstants.setting.documentsSettings.acceptanceAct.FAMILIAR_WITH_TEXT
}

export const reportForm039HideZero = () => {
  const settings = getUserDocumentSettings()
  return !!(settings && settings.report_039_cell_hide_zero)
}

export const physicianProtocolHideInfoBlock = () => {
  const settings = getUserDocumentSettings()
  return !!(settings && settings.physician_protocol_hide_info_block)
}

export const actWithRequisitesTitle = () => {
  const settings = getUserDocumentSettings()
  return settings && settings.act_with_requisites_title ? settings.act_with_requisites_title : null
}

export const actWithRequisitesConsentText  = () => {
  const settings = getUserDocumentSettings()
  return settings && settings.act_with_requisites_consent_text ? settings.act_with_requisites_consent_text : null
}

export const actWithRequisitesHideContractNumber  = () => {
  const settings = getUserDocumentSettings()
  return settings && settings.act_with_requisites_hide_contract_number
    ? settings.act_with_requisites_hide_contract_number : false
}

export const actWithRequisitesHideServiceRenderedDate  = () => {
  const settings = getUserDocumentSettings()
  return settings && settings.act_with_requisites_hide_service_rendered_date
    ? settings.act_with_requisites_hide_service_rendered_date : false
}

export const actWithRequisitesNewSignerFormat  = () => {
  const settings = getUserDocumentSettings()
  return settings && settings.act_with_requisites_new_signer_format
    ? settings.act_with_requisites_new_signer_format : false
}

export const lastVisitShowCredentials  = () => {
  const settings = getUserDocumentSettings()
  return settings ? !!settings.last_visit_show_credentials : true
}

export const lastVisitShowEmptyField  = () => {
  const settings = getUserDocumentSettings()
  return settings ? !!settings.last_visit_show_empty_field : true
}

export const lastVisitHideDoctorColumn  = () => {
  const settings = getUserDocumentSettings()
  return settings ? !!settings.last_visit_hide_doctor_column : false
}

export const treatmentDiaryShowCredentials  = () => {
  const settings = getUserDocumentSettings()
  return settings ? !!settings.treatment_diary_show_credentials : true
}

export const treatmentDiaryShowEmptyField  = () => {
  const settings = getUserDocumentSettings()
  return settings ? !!settings.treatment_diary_show_empty_field : true
}

export const treatmentDiaryHideDoctorColumn  = () => {
  const settings = getUserDocumentSettings()
  return settings ? !!settings.treatment_diary_hide_doctor_column : false
}

const getUserDocumentSettings = () => {
  const userData = getUserData()
  return userData && userData.document_settings ? userData.document_settings : null
}
